
/**
 *	kunstraum.js
 *
 *  Main Script Logic for Kunstraum Frontend Web Application
 *  
 *  @author Leander Eyer <leander.eyer@elead.ch>
 */

import { loadModel } from './model/Model.js'

import Vue from 'vue'
import Kunstraum from './Kunstraum.vue'


// Initialize Device variables
Vue.prototype.$zoom = 1.0;
Vue.prototype.$width = 1024;
Vue.prototype.$height = 768;
Vue.prototype.$device = 'large';
Vue.prototype.$orientation = 'landscape';
Vue.prototype.$previewImageQuality = 'small';

/** Initialize on load event */
window.addEventListener('load', function () {
	window.onresize = optimizeSize;
	optimizeSize();
	loadModel(main);
});

/** Dynamic Sizing based on screen with	*/
function optimizeSize() {

	// Analyze Device Configuration
	let width = document.documentElement.clientWidth;
	let height = document.documentElement.clientHeight;
	let factorHeight = Math.round(height / 85);
	let factorWidth = Math.round(width / 110);
	let factor = Math.max(Math.min(factorHeight, factorWidth, 20), 10) * Vue.prototype.$zoom;
	document.getElementsByTagName('html')[0].style.fontSize = factor + "px";

	// Export Device Configuration
	Vue.prototype.$width = width;
	Vue.prototype.$height = height;
	Vue.prototype.$orientation = (width > height? 'landscape' : 'portrait');
	Vue.prototype.$device = (width >= 1000? 'large' : 'mobile');
	// use larger images when we use grids with few cells on still rather large monitors
	Vue.prototype.$previewImageQuality = width > 500 && width < 1000? 'large' : 'small';

	// Log Device Configuration
	console.log('Configuration: ' + Vue.prototype.$device  + ' / ' + Vue.prototype.$orientation + ' at ' + factor + 'px rem' + ' using ' + Vue.prototype.$previewImageQuality + ' images for screen (' + Vue.prototype.$width + 'x' + Vue.prototype.$height + ')');
}

//	Loading Animation: the indicator becomes visible if loading takes longer than 
//	1 second, and animates one dot every 250 milliseconds
let loadingTrigger = null;
let loadingAnimation = null;
loadingTrigger = setTimeout(function () {
	document.getElementById('app-loading').style.opacity = '1';
	loadingTrigger = null;
	loadingAnimation = setInterval(function () {
		document.getElementById('app-loading-indicator').childNodes[0].appendData(" .");
	}, 250);
}, 1000);

/** Run the Application */
function main() {

	// Build and mount the main Application
	new Vue({
		render: h => h(Kunstraum),
	}).$mount('#app');

	// stop and hide loading animation
	if (loadingTrigger != null) {
		clearTimeout(loadingTrigger);
	}
	if (loadingAnimation != null) {
		clearInterval(loadingAnimation);
	}
	document.getElementById('app-loading').style.opacity = 0;
	setTimeout(function () {
		document.getElementById('app-loading').style.display = 'none';
	}, 1000);

	// Make the app visible
	document.getElementById('app-wrapper').style.opacity = 1;

}
